import { connectString } from '../helpers/utils';

/**
 * Transform users
 * @param {Array} input users
 * @returns {Array} users
 */
export const transformUsers = (input = []) => {
	return input.map((item) => ({
		object: item.object,
		id: item.id,
		email: item.email,
		name: connectString(item.first_name, item.last_name)(' '),
		first_name: item.first_name,
		last_name: item.last_name,
		phone_number: item.phone_number,
		role: item.role,
		is_active: item.is_active,
		updated_at: item.updated_at,
		created_at: item.created_at,
	}));
};

/**
 * Transform user
 * @param {Array} input user
 * @returns {Array} user
 */
export const transformUser = (input = {}) => {
	return {
		object: input.object,
		id: input.id,
		email: input.email,
		name: connectString(input.first_name, input.last_name)(' '),
		first_name: input.first_name,
		last_name: input.last_name,
		phone_number: input.phone_number,
		role: input.role,
		is_active: input.is_active,
		updated_at: input.updated_at,
		created_at: input.created_at,
	};
};